const fontSizes = [12, 14, 16, 20, 24, 28, 36, 48, 64, 96];

export default fontSizes;
